import { useClubSettings } from "../../providers";
import { Branding, Links, PageMenu } from "../organisms";

export function WebsiteSettings() {
  const {
     webSettings ,
  } = useClubSettings();

  return (
    <div className="-mx-8 flex h-full flex-col gap-6 overflow-y-auto px-8 pb-24">
      <Links />
      <div className="border-t border-t-gray-300"></div>
      <PageMenu
        value={
          webSettings
            ? {
                membershipsNavEnabled: webSettings.membershipsNavEnabled,
                creditPacksNavEnabled: webSettings.creditPacksNavEnabled,
                productNavEnabled: webSettings.productNavEnabled,
                appointmentsNavEnabled: webSettings.appointmentsNavEnabled,
                timetableNavEnabled: webSettings.timetableNavEnabled,
                leadCaptureNavEnabled: webSettings.leadCaptureNavEnabled,
                yourWebsiteUrl: webSettings.yourWebsiteUrl,
                redirectUrl: webSettings.redirectUrl,
              }
            : undefined
        }
      />
      <div className="border-t border-t-gray-300"></div>
      {webSettings && <Branding clubSettings={webSettings} />}
    </div>
  );
}
